import { useMemo } from 'react';
import { defaultAnnotation } from '../constants';

function useDeviceTimeSeriesAnnotation({
  actionAnnotations: _actionAnnotations,
  userAnnotations: _userAnnotations,
  displayActionAnnotation = false,
  displayUserAnnotation = false
}) {
  const actionAnnotations = useMemo(
    () => (_actionAnnotations ? _actionAnnotations.reduce(addChartAnnotation, {}) : {}),
    [_actionAnnotations]
  );
  const userAnnotations = useMemo(
    () => (_userAnnotations ? _userAnnotations.reduce(addChartAnnotation, {}) : {}),
    [_userAnnotations]
  );

  return useMemo(
    () => ({
      clip: false,
      common: {
        drawTime: 'afterDatasetsDraw'
      },
      annotations: {
        ...(displayActionAnnotation ? actionAnnotations : {}),
        ...(displayUserAnnotation ? userAnnotations : {})
      }
    }),
    [userAnnotations, actionAnnotations, displayActionAnnotation, displayUserAnnotation]
  );
}

function addChartAnnotation(acc, annotation) {
  acc[annotation.annotationId] = toChartAnnotation(annotation);

  return acc;
}

function toChartAnnotation(annotation) {
  return {
    ...defaultAnnotation,
    scaleID: 'x',
    value: annotation.time,
    label: {
      display: false,
      content: annotation.name
    }
  };
}

export { useDeviceTimeSeriesAnnotation };
